function notifyLoading(message) {

    if (message == null){
        message='Loading...'
    }

    var modal = document.getElementById("notification");
    let header = modal.querySelector('.modal-header');
    let headingHtml = header.querySelector('h3');

    headingHtml.innerHTML = message;

    $(modal).addClass("active");
}

function stopNotifyLoading() {
    var modal = document.getElementById("notification");
    $(modal).removeClass("active");
}

function notifyError(heading, subheading) {
    var modal = document.getElementById("errorNotification");
    let header = modal.querySelector('.modal-header');
    let headingHtml = header.querySelector('h3');
    let subheadingHtml = header.querySelector('h4');

    if (heading){
        headingHtml.innerHTML = heading;
    } else {
        headingHtml.innerHTML = "";
    }
    if (subheading) {
        subheadingHtml.innerHTML = subheading;
    } else {
        subheadingHtml.innerHTML = "";
    }

    $(modal).addClass("active");
}

const userType = document.getElementById('userType') ? document.getElementById('userType').value : null;

function creatorsFromSource(r) {
    let disallowed = ["Agencies", "Artists", "Author", "Authors", "Authorities", "Authors of Some Repute", "Compiled", "Contributors", "Contributions", "Contributors", "Friends", "Hands", "Illustrators", "Kingstone Authors", "Musicians", "N/A", "Photographers", "photographers", "Poets", "Scholastic Inc", "Titan Comics", "Translators", "Writers"];
    let various = ["Various", "various", "Various Artists", "Various Authors", "Various Editors"];
    let filterCreators = c => !disallowed.includes(c.title.trim());
    let filterVarious = c => !various.includes(c.title.trim());

    let swap = name => name.replace(/([a-z \-\'A-Z]{0,})(, )([a-z \-\'A-Z]{0,})/m, "$3 $1")

    let authors = r.authors ? r.authors.filter(filterCreators).map(c => { return {creator:c.title,type:"auth",typeD:"Author"}}) : [];
    if (!authors.length > 0 && r.primary_author?.title != "" && !disallowed.includes(r.primary_author.title)) {
        authors.push({creator: swap(r.primary_author.title), type:"auth", typeD: "Author"});
    }

    let illustratorInAuthors = r.authors?.some(r=> r.illustrators?.indexOf(r) >= 0)

    let authorIsIllustrator = (r.primary_author.title === r.primary_illustrator || r.authors === r.illustrators || illustratorInAuthors);

    let illustrators = (r.illustrators?.length > 0 && authorIsIllustrator === false) ? r.illustrators.filter(filterCreators).filter(filterVarious).map(c => { return {creator:c.title,type:"ill",typeD:"Illustrator"}}) : [];
    
    if (!illustrators.length > 0 && r.primary_illustrator?.title != "" && !authorIsIllustrator && !disallowed.includes(r.primary_illustrator.title) && !various.includes(r.primary_illustrator.title)) {
        illustrators.push({creator: swap(r.primary_illustrator.title), type: "ill", typeD: "Illustrator"});
    }

    let editors = r.editors ? r.editors.filter(filterCreators).filter(filterVarious).map(c => { return {creator:c.title,type:"editor",typeD:"Editor"}}) : [];
    let compilers = r.compilers ? r.compilers.filter(filterCreators).filter(filterVarious).map(c => { return {creator:c.title,type:"other",typeD:"Compiler"}}) : [];
    let narrators = r.narrators ? r.narrators.filter(filterCreators).filter(filterVarious).map(c => { return {creator:c.title,type:"other",typeD:"Narrator"}}) : [];
    let selectors = r.selectors ? r.selectors.filter(filterCreators).filter(filterVarious).map(c => { return {creator:c.title,type:"other",typeD:"Selector"}}) : [];

    return [...authors, ...illustrators, ...editors, ...compilers, ...narrators, ...selectors].slice(0,3);
}


function isLibraryUser() {
    return userType === 'L' ? true : false;
}

function isSchoolUser() {
    return userType === 'S' ? true : false;
}

const activeBasketType = document.getElementById('activeBasketType') ? document.getElementById('activeBasketType').value : null;

function isForSchoolBasket() {
    return activeBasketType === 'forSchool' ? true : false;
}

const isEntitledValue = document.getElementById('isEntitled') ? document.getElementById('isEntitled').value : null;

function isEntitled() {
    return isEntitledValue === '1' ? true : false;
}

const isInternalValue = document.getElementById('showAverage') ? document.getElementById('showAverage').value : null;

function isInternal() {
    return isInternalValue === '1' ? true : false;
}

const isAdvancedOrLibraryUserValue = document.getElementById('showBookshelves') ? document.getElementById('showBookshelves').value : null;

function isAdvancedOrLibraryUser() {
    return isAdvancedOrLibraryUserValue === '1' ? true : false;
}

const imageURLPrefixValue = document.getElementById('imageUrlPrefix') ? document.getElementById('imageUrlPrefix').value : null;

function imageURLPrefix() {
    return imageURLPrefixValue;
}

const isAdvancedValue = document.getElementById('isAdvanced') ? document.getElementById('isAdvanced').value : null;

function isAdvancedSchoolsUser() {
    if (isSchoolUser()) {
        return isAdvancedValue === '1' ? true : false;
    } else {
        return false;
    }
}

const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

const IsBooksForTopic = (bookdata) => {
    if(bookdata) {
        var authorstring = bookdata.primary_author.title ? bookdata.primary_author.title : "";
        var subtitlestring = bookdata.subtitle ? bookdata.subtitle : "";
        authorstring = authorstring.replace(/\W+/g, '').toLowerCase();
        subtitlestring = subtitlestring.replace(/\W+/g, '').toLowerCase();

        if (authorstring == "booksfortopics" || subtitlestring == "booksfortopics") {
            return true;
        }
    }
    return false;
}

function currency(n, dp=2) {
    return Number(n).toLocaleString("en-GB", {style: "currency", currency: "GBP", minimumFractionDigits: dp});
}

function randomColour() {
    return 'rgba(' + Math.floor(Math.random() * 255) + ',' + Math.floor(Math.random() * 255) + ',' + Math.floor(Math.random() * 255) + ')';
}

const getProductImageLink = (ean) => {
    if (ean === null) {
        return "";
    }
    const imageFolder = ean.substring(ean.length-3);
    const fullLink = `${imageURLPrefix()}/covers/large/${imageFolder}/${ean}.jpg`;

    return fullLink;
}


// Source: https://levelup.gitconnected.com/converting-a-string-to-camelcase-in-javascript-f88a646a22b4

// util function to convert the input to string type
function convertToString(input) {
  
    if(input) { 
      
         if(typeof input === "string") {

              return input;
          }
        
         return String(input);
    }
    return '';
}


// convert string to words
function toWords(input) {							

 input = convertToString(input);
 
 var regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
 
 return input.match(regex);

}


// convert the input array to camel case
function toCamelCase(inputArray) {

  let result = "";

  for(let i = 0 , len = inputArray.length; i < len; i++) {

    let currentStr = inputArray[i];
  
    let tempStr = currentStr.toLowerCase();

    if(i != 0) {
  
      // convert first letter to upper case (the word is in lowercase) 
        tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);

     }
    
     result +=tempStr;
    
  }

  return result;
}

function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }
function capitalize(string) {
    if (typeof string !== 'string') return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function decodeHTML(html) {
	var txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
};

// function isAvailableToOrder(product) {
//     // if (!product.in_petranet) {
//     //     return false;
//     // }
//     // if (product.disallow_buy_box) {
//     //     return false;
//     // }
//     if (product.stock_level_display > 0 || product.dbdqtyheld > 0 || product.report_code == "NP" || product.distributor?.value == "ZZ89" || product.dbdqtyheld < 0 || (is_Numeric(product.dbdqtyheld) && product.dbdqtyheld == 0 && product.distributor?.value == "GA30" && !product.report_code) || (!product.report_code && !is_Numeric(product.dbdqtyheld))) {
//         return true;
//     }
//     return false;
// }

function getPublishDateText(publishDate) {
    let publishDateText = "";
    let now = new Date();
    let twoYearsFuture = new Date(now.getDate() + 730);

    if(publishDate > twoYearsFuture) {
        publishDateText = "forthcoming publication";
    } else if (publishDate > now) {
        publishDateText = "published " + publishDate.toLocaleDateString();
    } else {
        publishDateText = "published " + publishDate.toLocaleString('default', { month: 'long' }) + " " + publishDate.getFullYear();
    }
    return publishDateText;
}

function is_Numeric(num) {
    return !isNaN(parseFloat(num)) && isFinite(num);
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPostcodeFormat() { // CURRENTLY FOR UK ONLY [WIP]
    var regex = /^[A-Za-z]{1,2}[0-9Rr][A-Za-z0-9]?\s*[0-9][A-Za-z^CIKMOV]{2}/g;
    return regex;
}

function checkAvailability(hit, productPrice) {
    let isavailablebool = false;

    if (Number(productPrice) < 1 && !hit.enhanced) {
        isavailablebool = false;
    } else if (hit.min_price > 0) {
        isavailablebool = true;
    } else {
        isavailablebool = hit.hasstock == "1";
        // #923
        // isavailablebool = hit.hasstock == "1" && !(hit.distributor.value == "GA30" && hit._source.dbdqtyheld === 0 && hit.noreportcode === 0 && hit.peters_has_stock === 0 && hit.report_code != "NP") ? true : false;
    }

    if (isLibraryUser() && isavailablebool === false) {
        let productReportCode = hit.report_code;
        let nonCancellingReportCodes = ["BD", "CS", "IB", "IP", "MD", "NE", "NK", "NP", "NQ", "OA", "OB", "OF", "OO", "OS", "PK", "RE", "RF", "RP", "ST", "TF", "TU", "UC"];
        if (nonCancellingReportCodes.includes(productReportCode.trim())) {
            isavailablebool = true;
        }
    }

    return isavailablebool;
}

function getStockMessage(product, inBasketCheckout=false) {
    let now = new Date();
    let stockText = "";
    let stockTextArray = [];
    // let available = isAvailableToOrder(product);
    let available = checkAvailability(product, product.rrp);
    // let reportDueDate = new Date(product.report_due_date.split('-')[0],product.report_due_date.split('-')[1],product.report_due_date.split('-')[2]);
    let reportDueDate = new Date(product.report_due_date);
    let messageCssClass = "";
    
    if(product.report_code == "NP") {
        // let publishDate = new Date(product.publish_date.split('-')[0],product.publish_date.split('-')[1],product.publish_date.split('-')[2]);
        let publishDate = new Date(product.publish_date);

        stockTextArray.push("Not yet published");

        if (publishDate > now) {
            stockTextArray.push(getPublishDateText(publishDate));
        }

        if (product.report_due_date && product.report_due_date != '0000-00-00') {
            if (reportDueDate > now) {
                stockTextArray.push("reported by publisher (due " + publishDate.toLocaleDateString() + ")");
            }
        }
    } else if(product.distributor?.value == "ZZ89"){
        stockTextArray.push("Available");
    } else {
        if (available === false) {
            if ((product.in_petranet == 0) || (product.disallow_buy_box === true)) {
                stockTextArray.push("not sold by Peters");
            } else {
                stockTextArray.push("item not available");
            }
        }
        /* check if in stock at peters */
        if (product.stock_level_display > 0) {
            /* check peters stock levels to see if plural */
            if(product.stock_level_display == 1) {
                stockTextArray.push(product.stock_level_display + " copy in stock");
            } else {
                stockTextArray.push(product.stock_level_display + " copies in stock");
            }
        }
        /* check distributor stock levels and reportings */
        if (product.dbdqtyheld > 0 && product.dbdqtyheld < 10) {
            stockTextArray.push("less than 10 copies available at publisher");
        } else if (product.dbdqtyheld > 9 && product.dbdqtyheld < 100) {
            stockTextArray.push("more than 10 copies available at publisher"); 
        } else if (product.dbdqtyheld > 99) {
            stockTextArray.push("more than 100 copies available at publisher"); 
        } else if (product.dbdqtyheld < 0) {
            /* Some publishers use -1 to mean they have stock but won't say the quantity */
            if (product.distributor?.value == "MA03" || product.distributor?.value == "OX01" || product.distributor?.value == "CA01" || product.distributor?.value == "GR40") {
                stockTextArray.push("more available from publisher");
            } else {
                stockTextArray.push("publisher currently has no stock but may print more");
            }
        } else {
            /* distributor stock level = 0 */
            /* If Gardners is set as the default distributor, 0 doesn't mean anything. But it's still unavailable if there is a report code */
            if (is_Numeric(product.dbdqtyheld) && product.distributor?.value == "GA30" && !product.report_code) {
                stockTextArray.push("available to order");
            } else if (is_Numeric(product.dbdqtyheld) && product.dbdqtyheld == 0) {
                if(product.report_code) {
                    stockTextArray.push("0 copies available at publisher");
                } else {
                    stockTextArray.push("publisher currently has no copies available, no report");
                }
            } else if (!product.report_code) {
                stockTextArray.push("more available from publisher");
            }
        }
        if (product.report_code) {
            if (product.report_code == "RP" && (product.report_due_date && product.report_due_date != '0000-00-00')) {
                if (reportDueDate > now) {
                    stockTextArray.push("reported by publisher (" + product.rpname + ", due " + reportDueDate.toLocaleDateString() + ")");
                } else {
                    stockTextArray.push("reported by publisher (" + product.rpname + ")");
                }
            } else {
                stockTextArray.push("reported by publisher (" + product.rpname + ")");
            }
        }
        /* if we don't have any data on the stock status say the item is unavailable; this should never happen as all cases are covered above */
        if (stockTextArray.length === 0) {
            stockTextArray.push("item not available");
        }
    }
    
    /* don't show this for logged out users, see issue #359 */
    if (isEntitled()) {
        if (available === false) {
            messageCssClass += " noStock ";
            if (!inBasketCheckout) {
                messageCssClass += "limitedStock ";
                stockText += "<i class='warningTooltip fas fa-exclamation-circle' title='We may not be able to supply this title.'></i>&nbsp;";
            } else {
                stockText += "<i class='warningTooltip fas fa-exclamation-circle petersPink' title='We may not be able to supply this title.'></i>&nbsp;";
            }
        } else if (product.report_code != "" && product.report_code != "NP") {
            if (!inBasketCheckout) {
                messageCssClass += " limitedStock ";
                stockText += "<i class='warningTooltip fas fa-exclamation-circle' title='We may not be able to supply this title.'></i>&nbsp;";
            } else {
                stockText += "<i class='warningTooltip fas fa-exclamation-circle petersPink' title='We may not be able to supply this title.'></i>&nbsp;";
            }
        }
    } else if (available === false) {
        messageCssClass += " noStock ";
    }

    /* simplified message for logged out users */
    if (!isEntitled()) {
        // if (available === false) {
        //     stockText += "Not available to order";
        // } else {
        //     stockText += "Available to order";
        // }
        stockText += "Please create an account to check availability. Please note that Peters does not supply to private individuals.";
    } else {
        /* loop through text array and generate a single formatted string */
        stockText += capitalizeFirstLetter(stockTextArray.join(", "));
    }

    return("<span class='" + messageCssClass + "'>" + stockText + "</span>");
}

// this function call all other functions

function toCamelCaseString(input) {						

    let words = toWords(input);

    return toCamelCase(words);
}

function handleImageError(e){

    let image = e.target;

    if(image.tagName !== "IMG"){
        return false;
    }

    // $image.off();
    if(image.classList.contains('centerfoldImage') || image.classList.contains('backcoverImage') || image.classList.contains('additionalImage')) {
        // Locate slide in which image is stored in and, if found, hide it; otherwise, just hide image?
        var slide = image.closest('.slick-slide');
        if (slide) {
            slide.classList.add("hiddenImage");
            $('#alternateBookImageContainer').slick('slickUnfilter').slick('slickFilter', ':not(.hiddenImage)');
        } else {
            image.style.display = 'none';
        }
    } else if(image.classList.contains('bookPackItemImage')) {
        // Locate slide in which "book pack item" image is stored in and, if found, hide it; otherwise, just hide image?
        var slide = image.closest('.slick-slide');
        if (slide) {
            slide.classList.add("hiddenImage");
            $('#bookPackImages').slick('slickUnfilter').slick('slickFilter', ':not(.hiddenImage)');
        } else {
            image.style.display = 'none';
        }
    } else {
        image.setAttribute('src', '/assets/img/nocover.png');
        image.setAttribute('class', 'noCoverImage');
    }
};
// This builds our dotdigital cart data
function basketToDotdigitalCart(basket, programID, cartDelay) {
    const cart = {
        programID: Number,
        // cartDelay: Number,
        cartID: String,
        cartPhase: String,
        currency: String,
        subtotal: Number,
        discountAmount: Number,
        taxAmount: Number,
        grandTotal: Number,
        cartUrl: Number,
        modifiedDate: String,
        lineItems: Object
    }
    // Program IDs from dotdigital 358209 = "Abandoned Cart"
    if(!programID) programID = 358209
    // Minutes until email is sent 4320 = 72 hours
    // if(!cartDelay) cartDelay = 4320

    cart.programID = programID // This is the DD program ID, so the email this cart is associated to
    // cart.cartDelay = cartDelay // Minutes until email is sent 4320 = 72 hours
    cart.cartID = basket.id
    cart.cartPhase = basket.cartPhase
    cart.currency = "GBP"
    cart.subtotal = Math.round((basket.subtotal + Number.EPSILON) * 100) / 100
    cart.discountAmount = Math.round((basket.discountAmount + Number.EPSILON) * 100) / 100
    // cart.taxAmount = currency(basket.taxAmount)
    cart.grandTotal = Math.round((basket.grandTotal + Number.EPSILON) * 100) / 100
    cart.cartUrl = basket.cartUrl
    cart.modifiedDate = basket.modifiedDate
    cart.lineItems = basket.items
    
    return cart;
}
// This tries to insert the tracking JS if applicable
function trackBasket(basket, close, programID, cartDelay) {
    if(!basket || !basket.id) {
        return false; // No basket to track
    }
    
    if((basket.email && basket.email?.includes("wilxite")) || basket.isInternal == 1 || basket.accountType != "S" || basket.vcApplied == true || basket.nonUk == true) {
        return false;
    }
    const cart = basketToDotdigitalCart(basket, programID, cartDelay)
    const script = document.createElement("script");
    script.src = `/assets/js/dotdigitalCartTracker.js?r=${Math.random()}`;
    script.type = "text/javascript";
    if(close) {
        script.id = "dotdigitalCartTrackerComplete";
        cart.cartPhase = "ORDER_COMPLETE";
    } else {
        script.id = "dotdigitalCartTracker";
    }
    script.async = true;
    
    script.setAttribute("cart", JSON.stringify(cart));
    script.setAttribute("email", basket.email);

    document.body.appendChild(script);
}

function filterToIsbns($inputField, $countField, $validationField, callback) {
    $inputField.on('change', function(){
        if($(this).val()) {
            var matches = $(this).val().replace(/\s+/gm, ',').replace(/[^0-9,]/g, '').replace(/,+/g, ',').split(",");
            var matches2 = [];
            for (var i=0; i<matches.length; i++) {
                if (matches[i].length >= 10 && matches[i].length <= 13) {
                    matches2.push(matches[i]);
                }
            }
            $(this).val(matches2.join(","));
            
            if(matches2.length > 500) {
                $validationField.addClass('disabled');
            } else {
                $validationField.removeClass('disabled');
            }

            $countField.text(matches2.length);
            if (typeof callback === 'function') callback()
        } else {
            $countField.text(0);
        }
    });
}
// custom events methods 
// see https://www.falldowngoboone.com/blog/talk-to-your-react-components-with-custom-events/
function on(eventType, listener) {
    document.addEventListener(eventType, listener);
}

function off(eventType, listener) {
    document.removeEventListener(eventType, listener);
}
function once(eventType, listener) {
    on(eventType, handleEventOnce);
    function handleEventOnce(event) {
        listener(event);
        off(eventType, handleEventOnce);
    }
}

function trigger(eventType, data) {
    const event = new CustomEvent(eventType, { detail: data });
    document.dispatchEvent(event);
}

function slugify(string) {
    return string.replace(/[^-a-zA-Z0-9\s]/g, '');
}

export {
    notifyError,
    notifyLoading,
    stopNotifyLoading,
    isLibraryUser,
    isSchoolUser,
    isEntitled,
    isInternal,
    creatorsFromSource,
    isAdvancedOrLibraryUser,
    isForSchoolBasket,
    imageURLPrefix,
    isAdvancedSchoolsUser,
    isNumeric,
    currency,
    randomColour,
    getProductImageLink,
    convertToString,
    toWords,
    toCamelCase,
    camelize,
    toCamelCaseString,
    handleImageError,
    capitalize,
    on, 
    once,
    off, 
    trigger,
    decodeHTML,
    IsBooksForTopic,
    getStockMessage,
    checkAvailability,
    getPostcodeFormat,
    basketToDotdigitalCart,
    trackBasket,
    capitalizeFirstLetter,
    filterToIsbns,
    slugify
};